"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var CardRowSelectEditor_1 = require("../../../../shared/components/editors/CardRowSelectEditor");
var TextArea = antd_1.Input.TextArea;
var DlgSendBroadcastRawUserMessage = /** @class */ (function (_super) {
    __extends(DlgSendBroadcastRawUserMessage, _super);
    function DlgSendBroadcastRawUserMessage(props) {
        return _super.call(this, props) || this;
    }
    DlgSendBroadcastRawUserMessage.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            _this.setState({
                visible: data.visible,
                dialogTitle: data.dialogTitle,
                message_title: data.messageTitle,
                message_text: data.messageText,
                brand_id: data.brandId,
                brand_title: data.brandTitle,
                brands_avail: data.brandsAvail,
                language_id: data.languageId,
                language_title: data.languageTitle,
                languages_avail: data.languagesAvail
            });
        });
        this.setState({
            visible: false,
            dialogTitle: "",
            message_title: "",
            message_text: "",
            brand_id: 0,
            brand_title: "",
            brands_avail: [],
            language_id: 0,
            language_title: "",
            languages_avail: []
        });
        this.doReSetRules();
    };
    DlgSendBroadcastRawUserMessage.prototype.doReSetRules = function () {
        this.setState({
            brand_rules: { isError: false },
            language_rules: { isError: false },
            message_title_rules: { isError: false },
            message_text_rules: { isError: false }
        });
    };
    DlgSendBroadcastRawUserMessage.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
    };
    DlgSendBroadcastRawUserMessage.prototype.isDataValid = function () {
        this.doReSetRules();
        var is_data_valid = true;
        if ((!this.state.brand_title) || (this.state.brand_title.length === 0)) {
            this.setState({
                brand_rules: {
                    isError: true,
                    errorMessage: "Поле [бренд] не выбрано!"
                },
            });
            is_data_valid = false;
        }
        if ((!this.state.language_title) || (this.state.language_title.length === 0)) {
            this.setState({
                language_rules: {
                    isError: true,
                    errorMessage: "Поле [язык] не выбрано!"
                },
            });
            is_data_valid = false;
        }
        if ((!this.state.message_text) || (this.state.message_text.length === 0)) {
            this.setState({
                message_text_rules: {
                    isError: true,
                    errorMessage: "Поле [текст сообщения] не заполнено!"
                },
            });
            is_data_valid = false;
        }
        if ((!this.state.message_title) || (this.state.message_title.length === 0)) {
            this.setState({
                message_title_rules: {
                    isError: true,
                    errorMessage: "Поле [тема сообщения] не заполнено!"
                },
            });
            is_data_valid = false;
        }
        return is_data_valid;
    };
    DlgSendBroadcastRawUserMessage.prototype.handleYes = function () {
        if (this.isDataValid()) {
            this.props.controller.Close();
            if (this.props.controller.DATA.onYes) {
                this.props.controller.DATA.onYes(this.state.message_title, this.state.message_text, this.state.brand_id, this.state.language_id);
            }
        }
    };
    DlgSendBroadcastRawUserMessage.prototype.handleClose = function () {
        this.props.controller.Close();
    };
    DlgSendBroadcastRawUserMessage.prototype.onMessageTitleChange = function (e) {
        var _this = this;
        this.setState({
            message_title: e.target.value,
            message_title_rules: { isError: false }
        }, function () {
            _this.props.controller.SetMessageTitle(_this.state.message_title);
        });
    };
    DlgSendBroadcastRawUserMessage.prototype.onMessageBodyChange = function (e) {
        var _this = this;
        this.setState({
            message_text: e.target.value,
            message_text_rules: { isError: false }
        }, function () {
            _this.props.controller.SetMessageText(_this.state.message_text);
        });
    };
    DlgSendBroadcastRawUserMessage.prototype.getMessageTitleErrorRenderObject = function () {
        if (this.state.message_title_rules.isError) {
            return (React.createElement("div", { style: { width: "100%", textAlign: "left", margin: 5, marginLeft: 0, color: "red" } }, this.state.message_title_rules.errorMessage));
        }
        else {
            return null;
        }
    };
    DlgSendBroadcastRawUserMessage.prototype.getMessageTextErrorRenderObject = function () {
        if (this.state.message_text_rules.isError) {
            return (React.createElement("div", { style: { width: "100%", textAlign: "left", margin: 5, marginLeft: 0, color: "red" } }, this.state.message_text_rules.errorMessage));
        }
        else {
            return null;
        }
    };
    DlgSendBroadcastRawUserMessage.prototype.render = function () {
        var _this = this;
        return React.createElement(antd_1.Modal, { title: this.state.dialogTitle, visible: this.state.visible, onOk: this.handleYes.bind(this), wrapClassName: "vertical-center-modal", onCancel: this.handleClose.bind(this), okText: "\u0414\u0410", cancelText: "\u041D\u0415\u0422", closable: true, maskClosable: false, okType: "primary", style: { minWidth: 600 } },
            React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", } },
                React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Бренд:", placeholder: "Выберите бренд" }, value: { key: this.state.brand_id, value: this.state.brand_title }, onValueChanged: function (newVal) {
                        _this.setState({
                            brand_id: newVal.key,
                            brand_title: newVal.value,
                            brand_rules: { isError: false }
                        }, function () {
                            _this.props.controller.SetBrandId(_this.state.brand_id);
                            _this.props.controller.SetBrandTitle(_this.state.brand_title);
                        });
                    }, items: this.state.brands_avail, required: true, rules: this.state.brand_rules }),
                React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Язык:", placeholder: "Выберите язык" }, value: { key: this.state.language_id, value: this.state.language_title }, onValueChanged: function (newVal) {
                        _this.setState({
                            language_id: newVal.key,
                            language_title: newVal.value,
                            language_rules: { isError: false }
                        }, function () {
                            _this.props.controller.SetLanguageId(_this.state.language_id);
                            _this.props.controller.SetLanguageTitle(_this.state.language_title);
                        });
                    }, items: this.state.languages_avail, required: true, rules: this.state.language_rules }),
                React.createElement("div", { style: { width: "100%", textAlign: "left", fontWeight: "bold", margin: 5, marginLeft: 0 } }, "\u0422\u0435\u043C\u0430 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F"),
                React.createElement(antd_1.Input, { onChange: this.onMessageTitleChange.bind(this), value: this.state.message_title }),
                this.getMessageTitleErrorRenderObject(),
                React.createElement("div", { style: { width: "100%", textAlign: "left", fontWeight: "bold", margin: 5, marginLeft: 0 } }, "\u0422\u0435\u043A\u0441\u0442 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F"),
                React.createElement(TextArea, { rows: 4, onChange: this.onMessageBodyChange.bind(this), value: this.state.message_text }),
                this.getMessageTextErrorRenderObject()));
    };
    return DlgSendBroadcastRawUserMessage;
}(React.Component));
exports.default = DlgSendBroadcastRawUserMessage;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ui/DlgSendBroadcastRawUserMessage.tsx
// module id = 2448
// module chunks = 0